export enum MessageType {
    SYNC = 1,
    ASYNC = 2
}
